import React from "react";
import { Link, useParams } from "react-router-dom";
import { AiOutlineEdit } from "react-icons/ai";
import { RiDeleteBin6Line } from "react-icons/ri";
import { BiShow } from "react-icons/bi";
import { useCurrent } from "../../hooks";
import { getLangText } from "../../utils/global";
import { useTranslation } from "react-i18next";

const ListVendorsItem = ({ item, editHandeler, deleteHandeler }) => {
  const { currentCompanyId, currentBranchId, currentLangId } = useCurrent();
  const params = useParams();
  const [t] = useTranslation("global");

  return (
    <div className="w-[98%] mx-auto">
      <div className="flex justify-between items-center gap-2 bg-white border-b border-[#ddd0bf] border-opacity-40 p-2 hover:bg-[#F5F8F1] transition text-[#261759] text-sm">
      <div className="flex-1 text-start">{getLangText(item?.fullname, currentLangId)}</div>
      <div className="w-32 shrink-0 text-center">{item.mobileNo}</div>
      <div className="w-32 shrink-0 text-center">
        {item.createdAt ? item.createdAt.substring(0, 10) : ""}
      </div>
      <div
        className={`w-24 shrink-0 text-center px-2 py-1 rounded-lg ${
          item.isActive ? "bg-green-200" : "bg-slate-200"
        }`}
      >
        {item.isActive ? t("product.active") : t("product.inactive")}
      </div>
      <div className="w-[96px] shrink-0 flex justify-center items-center gap-3">
        <Link
          className="text-[#261759]"
          to={`/${params.tenant}/vendors/show/${item._id}/${currentCompanyId}/${currentBranchId}`}
        >
          <BiShow size={18} />
        </Link>
        <div
          className="text-[#261759] cursor-default hover:text-indigo-800"
          onClick={() => editHandeler(item._id)}
        >
          <AiOutlineEdit size={18} />
        </div>
        <div
          className="text-[#261759] cursor-default hover:text-red-700"
          onClick={() => deleteHandeler(item._id)}
        >
          <RiDeleteBin6Line size={18} />
        </div>
      </div>
      </div>
      </div>
  );
};

export default ListVendorsItem;
